import { render, staticRenderFns } from "./P_2018-portfolio.vue?vue&type=template&id=30282dc7&scoped=true&"
import script from "./P_2018-portfolio.vue?vue&type=script&lang=js&"
export * from "./P_2018-portfolio.vue?vue&type=script&lang=js&"
import style0 from "./P_2018-portfolio.vue?vue&type=style&index=0&id=30282dc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30282dc7",
  null
  
)

export default component.exports